import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BucketBrandType from '../../quotes/entities/bucketBrandType';
import { Button } from '@ami/react/core';
import CustomQuoteDocument from '../../documents/customQuoteDocument';
import { ThumbBucketProfileStyleType } from '../../thumb-bucket-profiles/ThumbBucketProfileStyleType';
import ThumbExistingBucket from '../../quotes/entities/thumbExistingBucket';

class ProductExistingBucketDetailViewComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(ThumbExistingBucket).isRequired,
    quoteId: PropTypes.string,
    quoteProductId: PropTypes.string,
  };

  state = {
    downloadingDocument: false,
  };

  downloadDocument(i, photo) {
    const { quoteId, quoteProductId } = this.props;
    this.setState({ downloadingDocument: true });

    if (photo.imageUrl) {
      window.open(photo.imageUrl, '_blank');
      this.setState({ downloadingDocument: false });
    } else {
      CustomQuoteDocument.getDownloadExistingBucketPhotosUrl(
        quoteId,
        quoteProductId,
        photo.id
      )
        .then((response) => (window.location = response.url))
        .finally(() => {
          this.setState({ downloadingDocument: false });
        });
    }
  }

  render() {
    const { entity } = this.props;
    const { downloadingDocument } = this.state;

    return (
      <Fragment>
        <div className="justify-content-center text-center mb-2 quote-info">
          <div className="row">
            <label className="col-6 text-end">Style:</label>
            <div className="col-6 text-start">{entity.bucketStyle}</div>
          </div>
          <div className="row">
            <label className="col-6 text-end">Width:</label>
            <div className="col-6 text-start">{entity.width}"</div>
          </div>
          <div className="row">
            <label className="col-6 text-end">Capacity:</label>
            <div className="col-6 text-start">
              {entity.getBucketForDisplay()}
            </div>
          </div>
          <div className="row">
            <label className="col-6 text-end">Brand:</label>
            <div className="col-6 text-start">
              {entity.brand === BucketBrandType.ami.id
                ? `${BucketBrandType.ami.label} ${
                    entity.amiSerialNumber
                      ? `, serial #${entity.amiSerialNumber}`
                      : ''
                  }`
                : `${
                    entity.otherBrandName
                      ? entity.otherBrandName
                      : BucketBrandType.other.label
                  } ${
                    entity.amiSerialNumber
                      ? `, part #${entity.amiSerialNumber}`
                      : ''
                  }`}
            </div>
          </div>
          {entity.bucketStyle === ThumbBucketProfileStyleType.Digging && (
            <div className="row">
              <label className="col-6 text-end">Tooth Count:</label>
              <div className="col-6 text-start">{entity.toothCount}</div>
            </div>
          )}
          {entity.bucketStyle === ThumbBucketProfileStyleType.Digging && (
            <div className="row">
              <label className="col-6 text-end">Tooth Style:</label>
              <div className="col-6 text-start">{entity.toothStyle}</div>
            </div>
          )}
          <div className="row">
            <label className="col-6 text-end">Photos:</label>
            {entity.photos.length === 0 && (
              <div className="col-6 text-start">{`None`}</div>
            )}
            <div className="col-6 text-start">
              {entity.photos.map((item, i) => (
                <Button
                  key={i}
                  label={item.imageName ? item.imageName : item.imageKey}
                  onClick={() => this.downloadDocument(i, item)}
                  className="btn btn-link p-0"
                  showSpinner={downloadingDocument}
                  disabled={downloadingDocument}
                  iconName="download"
                />
              ))}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ProductExistingBucketDetailViewComponent;
